import CuentaForm from './CuentaForm'
export {CuentaForm}
export default CuentaForm
